import { NodeModel } from "../_model/NodeModel";
import { DecorationDiffuser } from "../diffuser/decorationDiffuser";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Diffuser extends NodeModel {
    constructor() {
        super("Diffuser");

        this.type = new Types().Diffuser;

        this.x = 0;
        this.y = 0;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 250;
        this.width = 250;
        this.tx = 0;
        this.Xw = 0;
        this.operationSelected = '';
        this.currentTempEm = null;
        this.srcImg = require("@/assets/Fluxogramas/difusor.png");
        this.data = [new Properties({...this })];

        this.decorate = async function(callback) {
            this.decorator = new DecorationDiffuser();
            await this.decorator.init(this, callback)
        };

        this.clone = () => {
            let cloned = new Diffuser()

            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.decorator = null
            cloned.readOnly = this.readOnly
            cloned.expressionVisible = this.expressionVisible
            cloned.data = this.data.map(d => d.clone());
            cloned.currentTempEm = this.currentTempEm

            return cloned
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.currentTempEm = node.currentTempEm
            this.data = node.data.map(d => new Properties({...d }));
        }

        this.update = (node) => {
            this.currentTempEm = node.currentTempEm
            if (node.attrs) {
                this.data = node.attrs
            }
        }
    }
}

export { Diffuser };